function Footer() {
  return <div className={"App-footer-wrapper"}>
      <footer className={"App-footer"}>
        Reijerscop 20 - De Meern - info@klever-bio.nl
      </footer>
    </div>;
}

export default Footer;